import { Pipe, PipeTransform } from '@angular/core';
import { UserEventType } from '../enums/user-event-type.enum';
import { getUserEventBusinessLabel } from '../constants/user-event-business-label-map';

@Pipe({
  name: 'userEventBusinessLabel',
  standalone: true,
})
export class UserEventBusinessLabelPipe implements PipeTransform {
  transform(value: keyof typeof UserEventType): string {
    return getUserEventBusinessLabel(value);
  }
}
